import { RBTechnical } from 'store/railsBuilder/reducer.types';

import { TECHNICAL_DEVICE_TYPE } from 'services/data-manager/constants';

export default function getVodDetailsStartTime(technicals: RBTechnical[]) {
    const technical = technicals?.find(({ deviceType }) =>
        deviceType?.includes(TECHNICAL_DEVICE_TYPE),
    );

    return technical?.period?.start;
}
